import BankingOverview from '../../../banking/components/BankingOverview';
import LegacyBankingOverview from '../../../banking/components/LegacyBankingOverview';
import {
    BankingExperience,
    useBankingExperience,
} from '../../../common/providers/BankingExperienceProvider';

const BankingTab = () => {
    const { bankingExperience } = useBankingExperience();

    return bankingExperience === BankingExperience.CASH_CARD_ACCT ? (
        <BankingOverview />
    ) : (
        <LegacyBankingOverview />
    );
};

export default BankingTab;
